import {Component, OnInit, HostListener, Inject} from '@angular/core';

@Component({
    selector: 'app-index',
    templateUrl: './index.component.html'
})
export class IndexComponent implements OnInit {
    constructor() {
    }

    year = new Date().getFullYear();

    ngOnInit() {
    }

}
